import { Button, IconButton, Paper, Typography } from "@material-ui/core"
import { RemoveCircle } from "@material-ui/icons"
import clsx from "clsx"
import PropTypes from "prop-types"
import { useContext, useState } from "react"
import { useHistory } from "react-router-dom"
import dragGray from "~/assets/Icons/noun_drag_3124730_gray.svg"
import HoverText from "~/components/Common/HoverText"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import CategoryContext from "~/contexts/Category"

import Box from "../../../components/Common/Box"
import useStyles from "./styles"

const AddArticleCard = ({
  article,
  type,
  addedArticles,
  setAddedType,
  setAddedArticles,
  provided,
}) => {
  const classes = useStyles()
  const history = useHistory()

  // const { courseArray, setCourseArray } = useContext(PathContext)
  const { openDialog, dialogs } = useContext(AppContext)
  const { categoryArticles, setSelectedArticle } = useContext(CategoryContext)

  const [highlight, setHighlight] = useState(
    addedArticles?.find((c) => c?.id === article?.id),
  )

  const handleOpenArticle = async () => {
    const articles = await openDialog("addArticleDialog", {
      openUpdate: true,
      article: article,
      type: article?.type,
    })
  }
  //remove for view type on pathCourses
  const deleteArticle = () => {
    setAddedType(addedArticles?.filter((c) => c?.id !== article?.id))
    let type = article?.type
    if (type === "doc") {
      setAddedArticles(
        addedArticles
          .concat(categoryArticles.filter((x) => x?.type === "update"))
          ?.filter((c) => c?.id !== article?.id),
      )
    } else if (type === "update") {
      setAddedArticles(
        addedArticles
          .concat(categoryArticles.filter((x) => x?.type === "doc"))
          ?.filter((c) => c?.id !== article?.id),
      )
    }
  }

  return (
    <Paper
      elevation={0}
      className={clsx(classes.paperRow, "pr-4")}
      style={{
        backgroundColor: type !== "view" && highlight ? "#D0D5DD" : "#fff",
      }}
      ref={provided?.innerRef}
      {...provided?.draggableProps}
    >
      {article?.image ? (
        <img
          src={JSON.parse(article?.image)?.url}
          alt={article.title}
          className="h-full aspect-video"
        />
      ) : (
        <Box className={classes.imgBox}></Box>
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        className={classes.cardContainer}
      >
        <Box display="flex" marginLeft="8px">
          {type !== "view" ? (
            <Typography
              variant="h3"
              color="primary"
              style={{ fontWeight: 600 }}
            >
              {article?.title}
            </Typography>
          ) : (
            <Button onClick={() => handleOpenArticle()} className="normal-case">
              <HoverText
                data={article?.title}
                size={40}
                variant="h3"
                className={classes.name}
              />
            </Button>
          )}
        </Box>
        <Box display="flex" alignItems="center">
          <PermissionsWrapper permissionGroup="admin">
            <Box marginRight="8px">
              <IconButton
                onClick={deleteArticle}
                className={classes.removeButton}
              >
                <RemoveCircle />
              </IconButton>
            </Box>
          </PermissionsWrapper>
          <PermissionsWrapper permissionGroup="admin">
            <div className={classes.dragHandle} {...provided.dragHandleProps}>
              <img src={dragGray} alt="" width="18px" />
            </div>
          </PermissionsWrapper>
        </Box>
      </Box>
    </Paper>
  )
}

AddArticleCard.propTypes = {
  article: PropTypes.object,
  type: PropTypes.string,
  addedArticles: PropTypes.array,
  setAddedType: PropTypes.func,
  setAddedArticles: PropTypes.func,
  provided: PropTypes.object,
}

export default AddArticleCard
